module.exports = "<svg id=\"eef989ef-48b5-4f1c-811d-ae7dfa198f26\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><path d=\"M15.39,31.42,7,42.1A.57.57,0,0,0,7,42.9H7l6.44,5.16a6.29,6.29,0,0,0,4.61,1.35c1.6-.17,12.45-13.21,15.88-19.16a127,127,0,0,0,8.79-18.53A6.32,6.32,0,0,0,39.15,3.6L31.46.6a.57.57,0,0,0-.73.32h0l-5,12.67a.57.57,0,0,0,.32.73h0L30.3,16c-1.45,3.13-3.08,6.26-4.84,9.32l0,0c-1.75,3-3.65,6-5.63,8.82l-3.6-2.89a.57.57,0,0,0-.8.09l0,0ZM31.58,15.95h0Z\" style=\"fill-rule:evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/phone.svg
// module id = 9pTP
// module chunks = 1